import { AwardsApi } from '../clients';
import { mapCycle } from '../mappers';

/**
 * Reads one cycle for the detail screen.
 *
 * A 404 is a legitimate answer — a deleted or mistyped id — so it resolves to
 * null and the page renders a not-found state. Everything else propagates, so
 * a 403 or 500 surfaces as an error rather than masquerading as not-found.
 */
export const getCycleById = async (cycleId) => {
  try {
    return mapCycle(await AwardsApi.getCycle(cycleId));
  } catch (error) {
    if (error?.response?.status === 404) return null;

    throw error;
  }
};
